import {AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';
import {AccountService} from '../../../services/account.service';
import {smoothlyMenu} from '../../../app.helpers';
import * as Constants from '../../../models/Constants';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ChangePasswordComponent} from '../../../views/change-password/change-password.component';
import {EditAccountComponent} from '../../../edit-account/edit-account.component';
import {MenuConfiguration, UserDto} from '../../../models/User';
import {ErisLoginService} from '../../../services/sso/eris-login.service';
import {User} from 'oidc-client';
import { UserService } from '../../../services/user.service';
import { FacilityService } from '../../../shared/services/facility.service';
import { UserOrganization } from '../../../models/ApplicationModel';
import { environment } from '../../../../environments/environment';
import { take } from 'rxjs/operators';

declare var jQuery: any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html',
  styleUrls: ['navigation.compnonet.css']
})

export class NavigationComponent implements OnInit {
  public userNameFirstLetter: string;
  public fullName: string;
  public roleCodes: string[] = [];
  public roleNames: string[] = [];
  public branchName: string;
  public constants: any = Constants
  public modalRef: BsModalRef;
  public departmentCodes: string[] = [];
  public menuConfigs: MenuConfiguration[] = [];
  public isInspector: boolean = false;
  public profileUrl = `${environment.stsAuthority}/manage/profile`;
  
  constructor(private router: Router, private accountService: AccountService, private erisLoginService: ErisLoginService, 
    private modalService: BsModalService, private userService: UserService, private facilityService: FacilityService) {
  }

  ngOnInit() {
    // Wait until OIDC user is in memory (interceptor/storage) before reading profile / calling APIs.
    this.erisLoginService.getUser().pipe(take(1)).subscribe(oidcUser => {
      if (!oidcUser) {
        return;
      }
      const profile = this.erisLoginService.getProfile();
      this.fullName = (profile && profile.given_name) ? profile.given_name : '';
      this.userNameFirstLetter = this.fullName ? this.fullName.charAt(0) : '?';

      let menu = this.accountService.getMenu();
      // Empty [] is truthy and was getting stuck after a swallowed GetUserMenus failure (200 + []).
      if (menu && menu.length > 0) {
        this.menuConfigs = menu;
      } else {
        this.userService.getUserMenus().subscribe(menuResp => {
          this.menuConfigs = menuResp || [];
          if (this.menuConfigs.length > 0) {
            this.accountService.storeMenuConfig(this.menuConfigs);
          } else {
            localStorage.removeItem('menu');
          }
        });
      }

      let user = this.accountService.getUserData();
      if (user) {
        this.setUserData(user);
        this.isInspector = this.accountService.isUserInspector();
        if (!this.router.url.startsWith('/inspections/view/')) {
          if (!user.hasUserDetail) {
            this.router.navigateByUrl('/account/edit');
          }
          if (this.accountService.isUserApplicant() && !this.accountService.isUserAbroadCGMPApplicant(user)) {
            this.handleTinData();
          }
        }
      } else {
        const userId = this.erisLoginService.getUserId();
        if (!userId) {
          console.error('OIDC profile missing userId/PrimarySid — cannot load /api/user');
          return;
        }
        this.userService.getUser(userId).subscribe(loaded => {
          this.setUserData(loaded);
          this.accountService.storeUserData(loaded);
          this.isInspector = this.accountService.isUserInspector();
          if (!this.router.url.startsWith('/inspections/view/')) {
            if (!loaded.hasUserDetail) {
              this.router.navigateByUrl('/account/edit');
            }
            if (this.accountService.isUserApplicant() && !this.accountService.isUserAbroadCGMPApplicant(loaded)) {
              this.handleTinData();
            }
          }
        });
      }
    });
  }

  handleTinData(){
    let userTinData = this.accountService.getUserTinData();
    if(userTinData){
      if(userTinData.length == 0){      
        this.router.navigate(['/manageTin']);
      }
    } else {
      this.facilityService.getOrganizationApplicantAssociations().subscribe(data => {
        this.accountService.storeUserTinData(data);
        if(data.length == 0){      
          this.router.navigate(['/manageTin']);
        }
      });
    }
  }

  toggleNavigation(): void {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  async logout() {
    this.accountService.removeData();
    // logout() clears the local session and redirects to the STS end-session endpoint.
    // Navigating in-app afterwards raced that redirect and could cancel the sign-out.
    await this.erisLoginService.logout();
  }

  setUserData(user : UserDto){
    this.roleCodes = (user.roles || []).map(u => u.code);
    this.roleNames = (user.roles || []).map(u => u.name);
    this.departmentCodes = (user.departments || []).map(u => u.code);
    if (user.branchOffice) {
      this.branchName = user.branchOffice.name;
    }
  }

  changePassword(isOdk = false) {
    const user = this.accountService.getUserData();
    const userID = user.id;
    const initialState = {
      title: 'Change Password',
      userID: userID,
      oldPasswordRequired: true,
      isOdkAccount: isOdk
    };
    this.modalRef = this.modalService.show(ChangePasswordComponent, {initialState, class: 'modal-sm'});
    this.modalRef.content.closeBtnName = 'Close';

  }

  openEditAccountModal() {
    const initialState = {
      isModal: true
    };
    this.modalRef = this.modalService.show(EditAccountComponent, {initialState, backdrop: 'static', keyboard: false});
    this.modalRef.content.closeBtnName = 'Close';
  }

  isActive(routeName) {
    return window.location.href.indexOf(routeName) > -1;
  }

  getRoleNames() {
    if (this.roleNames.length === 1) {
      return this.roleNames[0];
    } else if (this.roleNames.length > 1) {
      return this.roleNames.join(', ');
    }
  }

  navMenuClicked(value) {
    value.isExpanded = !value.isExpanded;  
  }

  isEditAccountPageShowing(){
    return this.router.url == '/account/edit';
  }
}
